import { Component } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
  selector: 'formly-array-type',
  template: `
    <p-divider
      *ngIf="
        props && props.attributes && props.attributes['separator']
      "
    ></p-divider>
    <div class="field mb-3 mt-1">
      <div
        class="flex flex-row align-items-start align-content-center"
      >
        <div>
          <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
          <label class="block">{{
            field.templateOptions.label
          }}</label>
          <div
            *ngIf="
              field.templateOptions.description &&
              (!showError || !formControl.errors)
            "
            class="text-sm my-2"
          >
            {{ field.templateOptions.description }}
          </div>
        </div>
        <button
          class="ml-auto w-min mb-1"
          pButton
          pRipple
          type="button"
          icon="pi pi-plus"
          [label]="addEntryStr"
          (click)="add()"
        ></button>
      </div>

      <div
        *ngIf="showError && formControl.errors"
        class="text-sm mt-2 p-error"
      >
        <formly-validation-message
          [field]="field"
        ></formly-validation-message>
      </div>
      <div
        *ngIf="
          props && props.attributes && props.attributes['warning']
        "
        class="text-sm my-1 text-yellow-400"
      >
        <span
          class="font-bold"
          i18n
          >Warnung:</span
        >
        {{ props.attributes['warning'] }}
      </div>
    </div>

    <div
      *ngFor="let field of field.fieldGroup; let i = index"
      class="p-fluid align-items-start grid"
    >
      <formly-field
        class="col-11 pt-0"
        [field]="field"
      ></formly-field>
      <div
        *ngIf="field.templateOptions['removable'] !== false"
        class="col-1 pb-0 text-right"
      >
        <button
          class="p-button-danger"
          pButton
          pRipple
          type="button"
          icon="pi pi-minus"
          (click)="remove(i)"
        ></button>
      </div>
    </div>
  `,
})
export class ArrayTypeComponent extends FieldArrayType {
  addEntryStr: string = $localize`Hinzufügen`;
}
